import React from 'react';
import PropTypes from 'prop-types';
import { useTranslator } from '@gameday/utils/hooks/useTranslator';
import {
    SituationWrapper,
    InningWrapper
} from './Summary.style';
import Score from './Score';

const DetailSituation = ({
    inning,
    halfInning = '',
    awayScore,
    homeScore,
    away,
    home,
    isTopInning,
    isScoringPlay,
    isMobile
}) => {
    const translationKey = halfInning === 'top' ? 'game_status_top' : 'game_status_bottom_abbrev';
    const inningHalfText = useTranslator(translationKey, halfInning === 'top' ? 'Top' : 'Bot');
    const showInning = inning && halfInning;

    return (
        <SituationWrapper $isMobile={isMobile}>
            {showInning && <InningWrapper>{inningHalfText} {inning}</InningWrapper>}
            <span> | </span>
            <Score
                awayScore={awayScore}
                homeScore={homeScore}
                away={away}
                home={home}
                isTopInning={isTopInning}
                isScoringPlay={isScoringPlay}
            />
        </SituationWrapper>
    );
};

DetailSituation.propTypes = {
    inning: PropTypes.number,
    halfInning: PropTypes.string,
    awayScore: PropTypes.number,
    homeScore: PropTypes.number,
    away: PropTypes.object,
    home: PropTypes.object,
    isTopInning: PropTypes.bool,
    isScoringPlay: PropTypes.bool,
    isMobile: PropTypes.bool
};

export default DetailSituation;
